const styles = (theme) => ({
  span: {
    width: (props) => `${props.open ? "311px" : "265px"}`,
    margin: "0",
    height: (props) => `${props.open ? "auto" : "auto"}`,
    transition: "all 0.3s",
    cursor: "pointer",
    backgroundColor: "white",
	position: "relative",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      height: "auto !important",
      width: "auto !important",
      minWidth: "265px",
      margin: "0 10px",
    },
  },
  boxShadow: {
    boxShadow: "5px 10px 50px rgba(0, 0, 0, 0.3)",
  },
  root: {
    cursor: "none !important",
    backgroundColor: "#E7E6E2",
    display: "flex",
    justifyContent: "center",
    transition: "background-color 0.3s, box-shadow 0.3s",
    alignItems: "center",
    width: "100%",
    height: "auto",
    padding: "1rem 1.5rem",
    boxShadow: "5px 10px 50px rgba(0, 0, 0, 0.3)",
    "&:hover": {
      backgroundColor: "#E7E6E2",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: { 
	padding: "1rem",
     backgroundColor: "#ccc",
      "&:hover": {
        backgroundColor: "#ccc",
      },
    },
  },
  expanded: {
    backgroundColor: "white",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  imgWrap: {
    flexBasis: (props) => (props.open ? "120px" : "100px"),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 0",
    transition: "all 0.3s",
  },
  img: {
    maxHeight: "2rem",
    objectFit: "contain",
    transition: "all 0.3s",
    width: (props) => (props.open ? "100%" : "auto"),
  },
  textWrap: {
    flexBasis: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    textAlign: "left",
    paddingLeft: "0",
  },
  content: {
    fontFamily: "Montserrat",
    letterSpacing: "0.01em",
    margin: 0,
    fontWeight: "400",
    fontSize: "14px",
    marginTop: "4px",
    color: "#1D1D1D",
    lineHeight: "17px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
		fontSize: "12px",
		marginTop: "3px",
		lineHeight: "15px",
    },
  },
  name: {
    fontFamily: "Montserrat",
    fontWeight: 700,
    fontSize: "1rem",
    lineHeight: "22.4px",
    margin: 0,
	color: "#1D1D1D",
    textTransform: "uppercase",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
		fontSize: "14px",
		lineHeight: "17px",
    },
  },
  desktopContent: {
    animation: "yellowToWhite 0.3s forwards",
  },
  bigText: {
    backgroundColor: "white",
    margin: "0",
    opacity: 0,
    top:"-10px",
    position:"relative",
    display: "none",
    padding: "0 20px 0 1.5rem",
    marginTop: "-1px",
    transform: "scale(0)",
    minWidth: "30ch",
    fontFamily: "Aktiv Grotesk",
    fontSize: 0,
    color: "transparent",
    lineHeight: "17px",
    letterSpacing: "0.01em",
    transition: "all 0.3s",
    height: "auto",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      height: "auto",
  		backgroundColor: (props) => `${props.open ? "white" : "#ccc"}`,
      transition: "all 0.3s",
      
        padding: "0 20px 10px 1rem",
      minWidth: "auto",
    },
  },
  showArrow: {
    display: "block !important",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      display: "none !important",
    },
  },
  arrow: {
    display: "none",
  },
  textOpened: {
    opacity: 1,
    fontSize: "14px",
    color: "#1D1D1D",
    display: "block",
    transformOrigin: "center",
    animation: "bounceIn 0.3s forwards",
  },
});

export default styles;
